import { useMaskito } from '@maskito/react';
import { useEffect,useRef, useState } from 'react';

import styles from './InputPhone.module.scss';

import phoneMask from '@/shared/lib/phoneMask';

interface InputPhoneProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  isValid?: boolean;
}

export const InputPhone: React.FC<InputPhoneProps> = ({
  value,
  onChange,
  placeholder = 'Введите номер телефона',
  error = false,
  isValid = false,
}: InputPhoneProps) => {
  const maskRef = useMaskito({ options: phoneMask });
  const rawRef = useRef<HTMLInputElement | null>(null);

  const [isReadonly, setReadonly] = useState(false);
  const [isFocused, setFocused] = useState(false);

  const setRefs = (el: HTMLInputElement | null) => {
    rawRef.current = el;
    maskRef(el);
  };

  const handleBlur = () => {
    setFocused(false);
    if (isValid) setReadonly(true);
  };

  const handleFocus = () => setFocused(true);

  const handleEdit = () => {
    setReadonly(false);
    requestAnimationFrame(() => rawRef.current?.focus());
  };

  useEffect(() => {
    if (!value) setReadonly(false);
  }, [value]);

  return (
    <div className={styles.label}>
      <h4 className={styles.title}>Номер телефона</h4>

      <input
        ref={setRefs}
        className={`${styles.input} ${error ? styles.error : ''} ${isReadonly ? styles.readonly : ''}`}
        type="tel"
        inputMode="tel"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        onFocus={handleFocus}
        readOnly={isReadonly}
      />

      {!isFocused && isReadonly && isValid && (
        <button
          type="button"
          className={styles.editButton}
          onClick={handleEdit}
          aria-label="Изменить номер"
        >
          изменить
        </button>
      )}
    </div>
  );
};
